import { render } from "./PositionDocumentPanel.vue?vue&type=template&id=65b82e5e"
import script from "./PositionDocumentPanel.vue?vue&type=script&lang=ts"
export * from "./PositionDocumentPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script